import * as React from "react";
const SvgEdpFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16.187 4.265A5.002 5.002 0 0 0 7.304 5.28l-.1.114a.98.98 0 0 0-.156.911 4.996 4.996 0 0 0 2.529 5.068A8 8 0 0 0 4 19v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1c0-3.573-2.343-6.6-5.576-7.626A5 5 0 0 0 17 7L19 7c1.18 0 1.387-1.684.242-1.97z" }));
export default SvgEdpFill;
